const SearchActionTypes = {
  TOGGLE_INPUT_HIDDEN: "TOGGLE_INPUT_HIDDEN",
  CLOSE_SEARCH_DRAWER: "CLOSE_SEARCH_DRAWER",
  SET_INPUT_VALUE: "SET_INPUT_VALUE",
};

export default SearchActionTypes;
